const AUS_PROD_MDM_ENDPOINT: string = 'https://api.aus.purplemdm.com';

const PROD = 'prod';
const AUS = 'aus';
const UK = 'uk';

let REGION: string = UK;

// Environment is determined at build time via VITE_APP_ENV
const ENV = import.meta.env.VITE_APP_ENV;

export default {
  setRegion(country: string) {
    switch (country) {
      case UK:
        REGION = UK;
        break;
      case AUS:
        REGION = AUS;
        break;
      default:
        REGION = UK;
    }
  },
  getEnvironment(): string {
    return ENV;
  },
  getMdmEndpoint() {
    // Use build-time injected endpoint
    const endpoint = import.meta.env.VITE_MDM_ENDPOINT;

    // For prod, check if we need AUS endpoint
    if (ENV === PROD && REGION === AUS) {
      return AUS_PROD_MDM_ENDPOINT;
    }

    return endpoint;
  }
}
